import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';

import {
    renderField,
    renderCurrencyFloat
} from "../../Utils/renderField/renderField";

function ListadoPreciosForm(props) {
    const {
        crear,
        modulo,
        periodoD,
        registroPrecio,
        modificarPrecio
    } = props;

    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar precio' : 'Nuevo precio';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver precio'
    }
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    return (
        <div>
            <NavbarModulo
                periodoD = {periodoD}
                modulo = {modulo}
                titulo = {titulo}
            />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        <div className='row mb-2'>
                            {crear === true && editar === false &&
                                <div className='col-2'>
                                    <Field
                                        name='sku'
                                        disabled={disabled}
                                        component={renderField}
                                        className="form-control"
                                        placeholder="Codigo"
                                        msj="Codigo"
                                    />
                                </div>
                            }
                            {crear === false && editar === true &&
                                <div className='col-2'>
                                    <Field
                                        name='sku'
                                        disabled={true}
                                        component={renderField}
                                        className="form-control"
                                        placeholder="Codigo"
                                        msj="Codigo"
                                    />
                                </div>
                            }
                            {crear === false && editar === false &&
                                <div className='col-2'>
                                    <Field
                                        name='sku'
                                        disabled={true}
                                        component={renderField}
                                        className="form-control"
                                        placeholder="Codigo"
                                        msj="Codigo"
                                    />
                                </div>
                            }
                            <div className='col-8'>
                                <Field
                                    name='producto'
                                    disabled={disabled}
                                    component={renderField}
                                    className="form-control"
                                    placeholder="Descripcion"
                                    msj="Descripcion"
                                />
                            </div>
                            <div className='col-2'>
                                <Field
                                    name='precio'
                                    disabled={disabled}
                                    component={renderCurrencyFloat}
                                    className="form-control"
                                    placeholder="Precio"
                                    msj="Precio"
                                />
                            </div>
                        </div>
                        <div className='d-flex flex-row mt-3'>
                            {disabled == false &&
                                <button
                                className='btn mr-2 mb-3 btn-primary'
                                onClick={registroPrecio}
                                >
                                {editar ? 'Modificar' : 'Guardar'}
                                </button>
                            }
                            <a
                                href = {`/#/rr_hh/${id_emp[5]}/listado_precios`}
                                className='btn btn-secondary mb-3'
                            >
                                Regresar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

ListadoPreciosForm.propTypes = {
    crear: PropTypes.bool,
    editar: PropTypes.bool,
    bloqueo: PropTypes.bool,
    modulo: PropTypes.object,
    periodoD: PropTypes.object,
    modificarListado: PropTypes.func,
    periodoD: PropTypes.object,
};

export default reduxForm({
    form: 'FormListadoPreciosRH',
})(ListadoPreciosForm);
